import HomeAssociate from './HomeAssociatePage';

export default HomeAssociate;
